import axios from "axios"

import config from "../service/config"

let headers = {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
}

let myAxios = axios.create({
    baseURL: config.API_URL,
    headers: headers,
})

let AuthAxios = axios.create({
    baseURL: config.API_URL,
    headers: headers,
    auth: {
        username: config.GATSBY_DRUPAL_USERNAME,
        password: config.GATSBY_DRUPAL_PASSWORD
    }
})

myAxios.interceptors.request.use(function(config) {
    return config;
}, function(error) {
    return Promise.reject(error);
});

myAxios.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    return Promise.reject(error)
});

const api = {
    login(params) {
        return new Promise((resolve, reject) => {
            myAxios.post("/login", params)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(e => {
                    reject(e)
                })
        })
    },

    siteSearch(params) {
        return new Promise((resolve, reject) => {
            myAxios.get(config.SITE_SEARCH, {
                params: {...params}
            })
                .then((response) => {
                    resolve(response.data)
                })
                .catch(e => {
                    reject(e)
                })
        })
    },

    subscribeNewsLetter(payload) {
        return new Promise((resolve, reject) => {
            AuthAxios.post(config.SITE_SEARCH, payload)
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },

    submitContactUsEnquiry(payload) {
        return new Promise((resolve, reject) => {
            AuthAxios.post(config.CONTACTUS_ENQUIRY, payload)
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    getCommonSpecs() {
        return new Promise((resolve, reject) => {
            myAxios.get(config.GET_COMMON_SPECS)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(e => {
                    reject(e)
                })
        })
    },
    getPopularSearch() {
        return new Promise((resolve, reject) => {
            myAxios.get(config.GET_POPULAR_SEARCH)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(e => {
                    reject(e)
                })
        })
    },
    getPopularSearchList() {
        return new Promise((resolve, reject) => {
            myAxios.get(config.SEARCHES.GET_POPULAR)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(e => {
                    reject(e)
                })
        })
    },
    postPopularSearch(id) {
        return new Promise((resolve, reject) => {
            myAxios.get(`${config.SEARCHES.POST_POPULAR}?id=${id}`)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(e => {
                    reject(e)
                })
        })
    },
    getFamilyMembers(id) {
        return new Promise((resolve, reject) => {
            myAxios.get(config.GET_FAMILY_MEMBERS+'/'+id)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(e => {
                    reject(e)
                })
        })
    },
    addFamilyMembers(payload) {
        return new Promise((resolve, reject) => {
            AuthAxios.post(config.ADD_FAMILY_MEMBER, payload)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(e => {
                    reject(e)
                })
        })
    },
    sitemapMenu() {
        return new Promise((resolve, reject) => {
            myAxios.get(config.GET_SITEMAP_MENU)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(e => {
                    reject(e)
                })
        })        
    },
    careerListing() {
        return new Promise((resolve, reject) => {
            myAxios.get(config.CAREER_LISTING)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(e => {
                    reject(e)
                })
        })        
    },
}

export default api
